/* eslint-disable */
import Vue from 'vue'
import Vant from 'vant'
import '@vant/touch-emulator'
import VConsole from 'vconsole'
import 'quill/dist/quill.snow.css'
import '@/assets/css/animate.css' // 动画样式的映入
import '@/assets/css/reset.less' // 样式重置
import 'vant/lib/index.css'
// px2rem 自适应
import 'lib-flexible'

var VueTouch = require('vue-touch')
Vue.use(VueTouch, { name: 'v-touch' })
import axios from 'axios'
import MD5 from 'blueimp-md5'
import TouchRipple from '@/components/clickActive/TouchRipple' // 点击特效的组件
Vue.component('TouchRipple', TouchRipple)
Vue.use(Vant)
if (
  process.env.NODE_ENV === 'development' ||
  process.env.VUE_APP_build_type === '110'
) {
  new VConsole()
}
let app = new Vue()
Vue.prototype.$bus = app

//测试服和本地 ifTest为true 线上为false
var ifTest = true
// 神策数据埋点的配置
const godPolicy = ifTest
  ? 'https://zhl-dc.zhihuiliu.com/sa?project=default'
  : 'https://zhl-dc.zhihuiliu.com/sa?project=production'
var pre = 'https://'
const md5 = MD5
// 本地联调的时候可以设置token
// setCookie(
//   'token',
//   '37a71842852a7441c0d2c7dbb3d97966bbf7520e2b8cb076b93b481294c32217',
//   10
// )
// 请求接口的配置
var ApiUrl = {
  ZHL_MULTI: process.env.VUE_APP_QIAOKAO_API,
  ZHL_MULTI_PAY: process.env.VUE_APP_ENGLISH_API,
  ZHL_ENGLISH: process.env.VUE_APP_ENGLISH_API,
  ZHL_UPLOAD: process.env.VUE_APP_UPLOAD_URL,
  ZHL_OAUTH: process.env.VUE_APP_OAUTH_API
}
var HttpFactory = {
  postUrlPay: function(params, successcb, failcb) {
    //pay
    sendRequest(params, ApiUrl.ZHL_MULTI_PAY, successcb, failcb)
  },
  postUrlPayNoLoading: function(params, successcb, failcb) {
    //pay
    sendRequest(params, ApiUrl.ZHL_MULTI_PAY, successcb, failcb, true)
  },
  postUrl: function(params, successcb, failcb) {
    //获取普通的接口数据
    sendRequest(params, ApiUrl.ZHL_MULTI, successcb, failcb)
  },
  upload: function(params, successcb, failcb, noloading) {
    //获取普通的接口数据
    sendRequest(params, ApiUrl.ZHL_UPLOAD, successcb, failcb, noloading)
  },
  //https://zhl-test.xxfz.com.cn/113-service/debug-8099/zhl-english/api
  postEnglishUrl: function(params, successcb, failcb) {
    sendRequest(params, ApiUrl.ZHL_ENGLISH, successcb, failcb)
  },
  postUrlNoLoading: function(params, successcb, failcb) {
    //获取普通的接口数据
    sendRequest(params, ApiUrl.ZHL_MULTI, successcb, failcb, true)
  },
  postNotoken: function(params, successcb, failcb) {
    //获取不需要token的接口比如分享页面里的数据请求
    sendRequestWithoutToken(params, ApiUrl.ZHL_MULTI, successcb, failcb)
  },
  postNotokenPay: function(params, successcb, failcb) {
    //获取不需要token的接口比如分享页面里的数据请求
    sendRequestWithoutToken(params, ApiUrl.ZHL_MULTI_PAY, successcb, failcb)
  },
  postNotokenNoLoading: function(params, successcb, failcb) {
    //获取不需要token的接口比如分享页面里的数据请求没有loading
    sendRequestWithoutToken(params, ApiUrl.ZHL_MULTI, successcb, failcb, true)
  },
  postTestNotoken: function(params, successcb, failcb) {
    sendRequestWithoutToken(params, ApiUrl.ZHL_MULTI_TEST, successcb, failcb)
  },
  postOauth: function(params, successcb, failcb) {
    // Oauth
    sendRequestWithoutToken(params, ApiUrl.ZHL_OAUTH, successcb, failcb)
  }
}
let timer = null
var jumpWebView = {
  //打开带导航栏的新窗口 √
  openNewWinWithNavigator: function(url) {
    clearTimeout(timer)
    timer = setTimeout(() => {
      if (typeof zhlWebView != 'undefined') {
        zhlWebView.openNewWebView(url, true)
      } else {
        location.href = url
      }
    }, 300)
  },
  //打开不带导航栏的新窗口
  openNewWinWithoutNavigator: function(url) {
    clearTimeout(timer)
    timer = setTimeout(() => {
      if (typeof zhlWebView != 'undefined') {
        zhlWebView.openNewWebView(url, false)
      } else {
        location.href = url
      }
    }, 300)
  },
  //设置右上角按钮的交互,其中methodName是绑定在window上的方法 √
  setTopRightCornerBtn: function(btnName, methodName) {
    if (typeof zhlWebView != 'undefined') {
      zhlWebView.addRightTitle(
        btnName,
        (getTerminal() == 'ios' ? '' : 'javascript:') + methodName + '()'
      )
    }
  },
  //跳转原生某个指定页面 √
  //其中最主要条件判断是op_type的值 决定跳转到哪里，如果需要跳转的页面有请求参数，首先应该从source_id赋值，其次根据不同的业务，app和web交互需要协商参数的定义。
  //当 op_type == 1 --- 好习惯页面的主要页面
  //              2 --- 绑定孩子页面的第一个页面
  //             14 --- 打开一个新的网页
  goSomePage: function(op_type, params) {
    if (typeof zhlWebView != 'undefined') {
      params = params ? params : {}
      var op_name = params.op_name ? params.op_name : '跳转到'
      var grade_id = params.grade_id ? params.grade_id : 3
      var volume_id = params.volume_id ? params.volume_id : 1
      var source_id = params.source_id ? params.source_id : 9406
      var redirect_url = params.redirect_url ? params.redirect_url : ''
      var remark = params.remark ? params.remark : 9406
      zhlWebView.openActivity(
        '{"op_type":"' +
          op_type +
          '","op_name":"' +
          op_name +
          '","grade_id":"' +
          grade_id +
          '","volume_id":"' +
          volume_id +
          '","source_id":"' +
          source_id +
          '","redirect_url":"' +
          redirect_url +
          '","remark":"' +
          remark +
          '"}'
      )
    }
  },
  //设置title
  setTitle: function(title) {
    if (typeof zhlWebView != 'undefined') {
      zhlWebView.setTitle(title)
    } else {
      var i = document.createElement('iframe')
      i.style.display = 'none'
      i.onload = function() {
        setTimeout(function() {
          i.remove()
        }, 9)
      }
      document.title = title
      document.body.appendChild(i)
    }
  },
  //操作标题栏, true 显示标题栏  false 隐藏标题栏
  handleNavigator(needNavigation) {
    if (typeof zhlWebView != 'undefined') {
      zhlWebView.setTitleBarStatus(needNavigation)
    }
  },
  //通知客户端教师主页的关注与取消
  attentionTeacherApp(teacher_uid, flag) {
    if (typeof zhlWebView != 'undefined') {
      zhlWebView.attentionTeacher(teacher_uid, flag)
    }
  },
  onOauthError(code) {
    if (typeof zhlWebView != 'undefined') {
      zhlWebView.onOauthError(code)
    }
  },
  //复制信息
  copyText(msg) {
    if (typeof zhlWebView != 'undefined') {
      zhlWebView.copyText(msg)
    }
  },
  //回调时刷新页面
  refreshThisPage: function() {
    if (typeof zhlWebView != 'undefined') {
      zhlWebView.refresh()
    } else {
      location.reload()
    }
  },
  refreshNativeWindow(type) {
    if (typeof zhlWebView != 'undefined') {
      zhlWebView.refreshNativeWindow(type)
    }
  },
  updateUserInfo() {
    if (typeof zhlWebView != 'undefined') {
      zhlWebView.updateUserInfo()
    }
  },
  //分享
  shareThisPage: function(page_url, img_url, title, content) {
    if (typeof zhlWebView != 'undefined') {
      zhlWebView.toShare(page_url, img_url, title, content)
    } else {
      // location.href = page_url;
    }
  },
  //订阅页面跳转 视频频道页面 zhlWebView.openChannelView(String text){"learning_res_id":1,"res_type":1}
  openChannelView: function(str) {
    if (typeof zhlWebView != 'undefined') {
      zhlWebView.openChannelView(str)
    } else {
      // location.href = page_url;
    }
  },
  //服务端请求分享
  toShareByType: function(type) {
    if (typeof zhlWebView != 'undefined') {
      zhlWebView.toShareByType(type)
    }
  },
  // 分享成功之后的
  shareSuccess: function() {
    console.log('分享成功！')
    setCookie('share', '1')
    location.reload()
  },
  //教师端主页面跳转
  openVideoPlay: function(list, index) {
    // console.log(JSON.stringify(list))
    var str =
      '[{"task_id":185,"task_video_id":2812,"cover_img_url":"http://106.14.37.113/debug/M01/00/04/ag4lcVw1UfOIX_fGAAAAPH45XN0AAAAPAP_8m8AAABU186.jpg","module_name":"第1页","ques_name":"第1题","teacher_name":"张爱莉","video_duration":400},{"task_id":185,"task_video_id":2808,"cover_img_url":"http://106.14.37.113/debug/M01/00/04/ag4lcVw1UfOIX_fGAAAAPH45XN0AAAAPAP_8m8AAABU186.jpg","module_name":"第1页","ques_name":"第1题","teacher_name":"张爱莉","video_duration":300},{"task_id":185,"task_video_id":2807,"cover_img_url":"http://106.14.37.113/debug/M01/00/04/ag4lcVw1UfOIX_fGAAAAPH45XN0AAAAPAP_8m8AAABU186.jpg","module_name":"第1页","ques_name":"第1题","teacher_name":"张爱莉","video_duration":200},{"task_id":185,"task_video_id":2806,"cover_img_url":"http://106.14.37.113/debug/M01/00/04/ag4lcVw1UfOIX_fGAAAAPH45XN0AAAAPAP_8m8AAABU186.jpg","module_name":"第1页","ques_name":"第1题","teacher_name":"张爱莉","video_duration":100}]'
    if (typeof zhlWebView != 'undefined') {
      // zhlWebView.openVideoPlay(str,index);
      zhlWebView.openVideoPlay(JSON.stringify(list), index)
    }
  },
  //频道主页跳转
  jumpVideoList: function(videoList) {
    // console.log(JSON.stringify(videoList))
    if (typeof zhlWebView != 'undefined') {
      zhlWebView.openVideoList(JSON.stringify(videoList))
    }
  },
  //视频播放跳转
  jumpVideoPlay: function(listObj) {
    if (typeof zhlWebView != 'undefined') {
      zhlWebView.openFavoriteVideo(JSON.stringify(listObj))
    }
  },
  //回退
  goBack: function() {
    if (typeof zhlWebView != 'undefined') {
      zhlWebView.goBack()
    } else {
      window.history.back()
    }
  },
  // 关闭当前页面
  getReturn: function() {
    if (typeof zhlWebView != 'undefined') {
      zhlWebView.getReturn()
    } else {
      window.history.back()
    }
  },
  //每次显示都会调用web的js方法
  onWebViewResume: function() {
    console.log('已打开页面！')
  },
  // 显示图形锁
  showGesLock: function() {
    if (typeof zhlWebView != 'undefined') {
      zhlWebView.showGesLock()
    }
  },
  //注册接收消息
  //pwd  接收消息的标识
  wapregistNotifyWithNotifyTag: function(password) {
    if (typeof zhlWebView != 'undefined') {
      zhlWebView.registNotifyWithNotifyTag(password)
    }
  },
  // pwd  发送消息的标识，与接收页面协调一致
  //method   接收页面要执行的方法
  wappostNotiyNameTagAndJsFunction: function(password, method) {
    if (typeof zhlWebView != 'undefined') {
      zhlWebView.postNotiyNameTagAndJsFunction(password, method)
    }
  },
  //支付
  /**
   * @param type 充值处理类型 1 充值余额 5 开通会员 6 升级会员 7 课程报名
   * @param channelId 充值渠道id
   * @param price 充值其他金额 100 表示 1 元 （至少充值一元）
   * @param productId 会员产品id （当type=1时，会员产品id设置为0； 当type=5时，会员产品id设置为购买会员的产品Id；当type=6时，会员产品id设置为升级后会员的产品Id）
   * @param currentMemberType 待升级会员类型 2 普通会员 3 金牌会员 （当type=6时该字段必须填写）
   * @param benefitUid 受益者用户id （给别人开通、给别人升级、给别人充值时用，一般是该值为当前登录的用户id）
   * @param voucherId 劵id
   * @param ifUseRemainMoney 是否使用了余额
   public void recharge(int type, int channelId, int price, int productId, int currentMemberType, int benefitUid, int voucherId, int ifUseRemainMoney)
   */
  commonPay: function(
    type,
    channelId,
    price,
    productId,
    currentMemberType,
    benefitUid,
    voucherId,
    ifUseRemainMoney,
    bid,
    remark
  ) {
    if (typeof zhlWebView != 'undefined') {
      zhlWebView.recharge(
        parseInt(type),
        parseInt(channelId),
        parseFloat(price),
        parseInt(productId),
        parseInt(currentMemberType),
        parseInt(benefitUid),
        parseInt(voucherId),
        parseInt(ifUseRemainMoney),
        parseInt(bid),
        remark
      )
    }
  },
  //ios内购
  iosPay: function(
    benefitUid,
    productId,
    productName,
    price,
    co_product_id,
    bid,
    mark,
    type
  ) {
    var mark = mark || ''
    if (typeof zhlWebView != 'undefined') {
      //17 直接购买巧币 18 充值会员 20 购买书籍
      zhlWebView.rechargeIOS(
        parseInt(benefitUid),
        parseInt(productId),
        productName,
        parseFloat(price),
        co_product_id,
        parseInt(bid),
        mark,
        type
      )
    }
  },
  //苹果是否审核
  iosIsAudit: function() {
    if (typeof zhlWebView != 'undefined') {
      //17 直接购买巧币 18 充值会员 20 购买书籍
      zhlWebView.iosIsAudit()
    }
  },
  //苹果恢复购买
  recoverPay: function() {
    if (typeof zhlWebView != 'undefined') {
      //17 直接购买巧币 18 充值会员 20 购买书籍
      zhlWebView.recoverPay()
    }
  },
  //ios购买书
  iosPayBook: function(id) {
    if (typeof zhlWebView != 'undefined') {
      //17 直接购买巧币 18 充值会员 20 购买书籍
      zhlWebView.purchaseBook(id)
    }
  },
  //iOS支付成功后调用
  rechargeMoneySuccess: function() {
    location.reload()
  },
  //跳转到绑定App Store
  toAppStoreBind: function(type) {
    if (typeof zhlWebView != 'undefined') {
      zhlWebView.openToAppFinanceBind(type)
    }
  },
  //跳转到App Store
  toAppStore: function() {
    if (typeof zhlWebView != 'undefined') {
      zhlWebView.openToAppStore()
    }
  },
  // 调用系统浏览器
  openSystemBrowser: function(url) {
    if (typeof zhlWebView != 'undefined') {
      zhlWebView.openSystemBrowser(url)
    } else {
      location.href = 'http://haiyouwei.zhihuiliu.com?id=12'
    }
  },
  chooseImageClick: function() {
    if (typeof zhlWebView != 'undefined') {
      zhlWebView.chooseImageClick()
    }
  },
  reloadCalendarData() {
    if (typeof zhlWebView != 'undefined') {
      zhlWebView.reloadCalendarData()
    }
  },
  setRightText(text) {
    if (typeof zhlWebView != 'undefined') {
      zhlWebView.setRightText(text)
    }
  },
  setRightImage(str) {
    if (typeof zhlWebView != 'undefined') {
      zhlWebView.setRightImage(str)
    }
  },
  //安卓端获取手机号码
  androidGetUserPhone() {
    if (typeof zhlWebView != 'undefined') {
      return zhlWebView.getUserPhone()
    }
    return ''
  }
}

/**
 *处理请求
 */
function handleStatus(textStatus, msg, failcb, issuccess, noJumpTo, isGoFrom) {
  if (textStatus == 'parsererror') textStatus = 400000
  if (textStatus == 'error') {
    if (failcb != undefined) failcb(textStatus)
    return
  }
  if (textStatus == 'timeout') textStatus = 408
  var html = '',
    reLogin = false
  switch (textStatus) {
    case 404:
      html = '您请求的内容不存在' //"请求资源找不到";
      break
    case 408:
      html = '请求超时，请重试'
      break
    case 500:
    case 400000:
      html = '服务器开了点小差，请稍后再试' //"服务器请求错误";
      break
    case 502:
      html = '网络不佳，请检查网络' //"网络请求失败，请检查网络";
      break
    case 100000:
    case 100001:
      html = '请重新登录' //"客户端权限不合法，请重新登陆";
      reLogin = true
      break
    case 2:
    case 100002:
      html = '请重新登录' //"用户未登录，请退出后重新登陆";
      reLogin = true
      break
    case 100003:
      html = '请重新登录' //"Token不合法，请重新登陆";
      reLogin = true
      break
    default:
      html = msg
  }
  if (issuccess) {
    html = msg
  }
  if (html && html.length > 12) {
    html = html.replace(/，/g, '，\n')
    html = html.replace(/,/g, ', \n')
  }
  app.$toast(html)
  if (!noJumpTo) {
    let href = ''
    if (!isGoFrom) {
      const params = getArgs()
      href = location.origin + location.pathname
      for (const key in params) {
        if (key !== 'code' && key !== 'SSOSESSION') {
          if (href.indexOf('?') !== -1) {
            href = href + `&${key}=${params[key]}`
          } else {
            href = href + `?${key}=${params[key]}`
          }
        }
      }
    } else {
      href = location.href
    }
    if (href.indexOf('EnglishLogin') < 0) {
      setTimeout(() => {
        loginOut()
        let url = './EnglishLogin.html?goFrom=' + encodeURIComponent(href)
        location.replace(url)
      }, 800)
    }
  }
  // jumpWebView.onOauthError(textStatus)
  if (failcb != undefined) failcb(textStatus)
}

/**
 * 处理服务端返回的数据结果
 */
function handleServerResult(
  responseObj,
  textStatus,
  failcb,
  issuccess,
  noJumpTo,
  isGoFrom
) {
  if (responseObj == undefined || responseObj == '') {
    handleStatus(textStatus, null, failcb, issuccess, noJumpTo, isGoFrom)
  } else {
    handleStatus(
      responseObj.code,
      responseObj.msg,
      failcb,
      issuccess,
      noJumpTo,
      isGoFrom
    )
  }
}

function showLoading() {
  app.$toast.loading({
    message: '加载中...',
    forbidClick: true,
    duration: 0
  })
}

function closeLoading() {
  app.$toast.clear()
}

//不需要token访问
function sendRequestWithoutToken(params, url, successcb, failcb, noloading) {
  sendAjax(params, url, 'freelogintoken', successcb, failcb, noloading)
}

/**
 * 其他正常接口
 */
function sendRequest(params, url, successcb, failcb, noloading) {
  if (getQueryString('token')) {
    setCookie('token', getQueryString('token'))
  }
  if (getCookie('token') == undefined) {
    //token过期
    console.log('token没有')
    app.$toast('请您先登录')
    let href = location.href
    setTimeout(() => {
      let url = './EnglishLogin.html?goFrom=' + encodeURIComponent(href)
      location.replace(url)
    }, 800)
    // jumpWebView.onOauthError(100003)
  } else {
    sendAjax(params, url, 'token', successcb, failcb, noloading)
  }
}

function sendAjax(params, url, token_type, successcb, failcb, noloading) {
  var scope = getScopeFromUserAgent()
  if (scope.length === 0) {
    scope =
      getTerminal() == 'ios'
        ? // ? 'com.zhl.zjqk.iphone.web'
          // : 'com.zhl.zjqk.aphone.web'
          'com.zhl.yj.listen.iphone.web'
        : 'com.zhl.yj.listen.aphone.web'
    if (
      getQueryString('business_id') &&
      Number(getQueryString('business_id')) !== zhlType.getBusinessId()
    ) {
      // 这儿筛掉200414的，默认就是200414的业务，不需要去取错误的公众号scope
      scope = zhlType.getScope()
    }
    // if(getQueryString('business_id')){
    //     scope = zhlType.getScope()
    // }
  }

  if (getQueryString('Scope')) {
    scope = getQueryString('Scope')
  }
  // var scope = 'com.zhl.enteacher.iphone';
  // var scope = 'com.zhl.zjqk.aphone';
  // var scope = getTerminal() == "ios" ? "com.zhl.qk.iphone.web" : "com.zhl.qk.aphone.web"
  // var scope = 'com.zhl.zjqk.iphone.web';
  // var scope='com.zhl.zjqk.aphone.web'

  var isGetPages = false
  if (typeof params.isgetpage != 'undefined') {
    isGetPages = params.isgetpage
    delete params.isgetpage
  }
  if (!params.business_id) {
    params.business_id = zhlType.getBusinessId()
    if (getQueryString('business_id')) {
      params.business_id = getQueryString('business_id')
    }
  }
  if (typeof params.op_path != 'undefined') {
    url += '/' + params.op_path.replace(/\./g, '/')
  }
  if (typeof ifTest != 'undefined' && ifTest) {
    // url = "http://101.132.26.110:8081/api/" + params.op_path.replace(/\./g, "/");
    // url = "http://192.168.100.113:8080/zhlhyw-api-project/api/" + params.op_path.replace(/\./g, "/");
    // url = "http://101.132.26.110:8081/zhlhyw-api-project/api/" + params.op_path.replace(/\./g, "/");
  }
  if (token_type == 'freelogintoken') {
    tokenCurrent = ''
  } else {
    var tokenCurrent = getCookie(token_type)
    if (tokenCurrent.length != 64) {
      tokenCurrent = 'bearer ' + tokenCurrent
    }
  }

  if (!noloading) {
    showLoading()
  }
  // // start
  axios({
    method: 'post',
    url: url,
    data: params,
    headers: {
      Authorization: tokenCurrent,
      Scope: scope,
      ...encryption(params)
    },
    timeout: 60000,
    responseType: 'json'
  })
    .then(function(res) {
      if (!noloading) {
        closeLoading()
      }
      if (res.status == 200) {
        if (res.data.code == 0) {
          setTimeout(function() {
            // if(isGetPages){
            //     successcb(res.data);
            // }else{
            //     successcb(res.data.data);
            // }
            successcb(res.data)
          }, 200)
        } else {
          handleServerResult(
            res.data,
            res.data.code,
            failcb,
            true,
            params.noJumpTo,
            params.isGoFrom
          )
        }
      } else {
        handleServerResult(
          res.data,
          res.data.code,
          failcb,
          true,
          params.noJumpTo,
          params.isGoFrom
        )
      }
    })
    .catch(function(error) {
      if (!noloading) {
        closeLoading()
      }
      handleServerResult(
        error.response,
        'error',
        failcb,
        false,
        params.noJumpTo,
        params.isGoFrom
      )
    })
}

var getArgs = function() {
  var args = new Object()
  var query = !window.location.search
    ? window.location.hash.substring(window.location.hash.indexOf('?') + 1)
    : window.location.search.substring(1)
  var pairs = query.split('&')
  for (var i = 0; i < pairs.length; i++) {
    var pos = pairs[i].indexOf('=')
    if (pos == -1) continue
    var argname = pairs[i].substring(0, pos)
    var value = pairs[i].substring(pos + 1)
    value = decodeURIComponent(value)
    args[argname] = value
  }
  return args
}

//设置cookie函数，三个参数，一个是cookie的名子，一个是值，一个是设置cookie保存时间，单位：天
function setCookie(name, value, days) {
  var days = arguments[2] ? arguments[2] : 30 //此 cookie 将被保存 30 天
  var exp = new Date() //new Date("December 31, 9998");
  exp.setTime(exp.getTime() + days * 86400000)
  document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString()
}

//取cookies函数
function getCookie(name) {
  var val = getQueryString(name)
  if (val) {
    return val
  }
  val = sessionStorage.getItem(name)
  if (val) {
    return val
  }
  var arr = document.cookie.match(new RegExp('(^| )' + name + '=([^;]*)(;|$)'))
  if (arr != null) {
    return unescape(arr[2])
  }
  return null
}

//删除cookie函数
function delCookie(name) {
  var exp = new Date()
  exp.setTime(exp.getTime() - 1)
  var cval = getCookie(name)
  if (cval != null) {
    document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString()
  }
}

function getQueryString(name) {
  var result = location.search.match(
    new RegExp('[?&]' + name + '=([^&]+)', 'i')
  )
  if (result == null || result.length < 1) {
    return ''
  }
  return result[1]
}

function getTerminal() {
  const ua = navigator.userAgent.toLowerCase()
  if (/iphone|ipad|ipod/.test(ua)) {
    return 'ios'
  } else if (/android/.test(ua)) {
    return 'android'
  }
}

function iosOrAndroid() {
  var u = navigator.userAgent,
    app = navigator.appVersion
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 //android终端或者uc浏览器
  // var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
  var isiOS = !!u.toLowerCase().match(/iphone|ipad|ipod|macintosh|mac os x/) //ios终端
  if (isAndroid) {
    return 'android'
  }
  if (isiOS) {
    return 'ios'
  }
}

// 判断是否是微信
function isWeiXin() {
  var ua = window.navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  } else {
    return false
  }
}

// 从 ua 中获取 scope
function getScopeFromUserAgent() {
  var u = window.navigator.userAgent.toLowerCase()
  var match_group = u.match(/scope\/.*?;/g)
  if (match_group && match_group.length > 0) {
    var u_subStr = match_group[0]
    if (u_subStr.length > 6) {
      u_subStr = u_subStr.substr(6, u_subStr.length - 6 - 1)
      return u_subStr + '.web'
    } else {
      return ''
    }
  }
  return ''
}

var zhlType = {
  //当前站点
  getMainUrl: function() {
    return location.origin
  },
  pressList: [],
  getBusinessId: function() {
    var bid = 0
    if (getQueryString('businessid')) {
      bid = getQueryString('businessid')
    } else if (getQueryString('business_id')) {
      bid = getQueryString('business_id')
    }
    bid = parseInt(bid)
    if (bid) {
      return bid
    }
    var url = zhlType.getMainUrl()
    for (var i = 0; i < zhlType.pressList.length; i++) {
      var pressModel = zhlType.pressList[i]
      if (url.indexOf(pressModel.mark + '.zhihuiliu.com') > 0) {
        return pressModel.business_id
      }
    }
    if (url.indexOf('wechat.zhihuiliu.com') > 0) {
      return 2
    }
    return process.env.VUE_APP_BUSINESS_ID
  },
  getClientId: function() {
    // 巧考学生端client_id：qiaokao
    // 浙教学生端client_id：qiaokao-zjxx
    //优化高分学生端client_id：qiaokao-yhxx
    var bid = zhlType.getBusinessId()

    for (var i = 0; i < zhlType.pressList.length; i++) {
      if (bid == zhlType.pressList[i].business_id) {
        return zhlType.pressList[i].client_id
      }
    }
    return 'qiaokao'
  },
  getMark: function() {
    var bid = zhlType.getBusinessId()
    for (var i = 0; i < zhlType.pressList.length; i++) {
      var pressModel = zhlType.pressList[i]
      if (pressModel.business_id == bid) {
        return pressModel.mark
      }
    }
  },
  //根据business_id获取App名字
  getBusinessName: function() {
    var bid = zhlType.getBusinessId()
    for (var i = 0; i < zhlType.pressList.length; i++) {
      var pressModel = zhlType.pressList[i]
      if (pressModel.business_id == bid) {
        return pressModel.name
      }
    }
    return '巧考'
  },
  //出版社名称
  getPressName: function() {
    var bid = zhlType.getBusinessId()
    for (var i = 0; i < zhlType.pressList.length; i++) {
      var pressModel = zhlType.pressList[i]
      if (pressModel.business_id == bid) {
        return pressModel.press
      }
    }
  },
  //获得app的下载网址
  getAppDownUrl: function() {
    var bid = zhlType.getBusinessId()
    for (var i = 0; i < zhlType.pressList.length; i++) {
      var pressModel = zhlType.pressList[i]
      if (pressModel.business_id == bid) {
        if (pressModel.new_mark || pressModel.new_mark == '') {
          return 'http://app.qiaokao.com/' + pressModel.new_mark
        } else {
          return 'http://app.qiaokao.com/' + pressModel.mark
        }
      }
    }
  },
  getAppId: function() {
    var bid = zhlType.getBusinessId()
    for (var i = 0; i < zhlType.pressList.length; i++) {
      var pressModel = zhlType.pressList[i]
      if (pressModel.business_id == bid) {
        return pressModel.app_id
      }
    }
  },
  //获取后台上微信公众号唯一标示符号
  getParamsAppId: function() {
    var bid = zhlType.getBusinessId()
    for (var i = 0; i < zhlType.pressList.length; i++) {
      var pressModel = zhlType.pressList[i]
      if (pressModel.business_id == bid) {
        return pressModel.my_app_id
      }
    }
  },
  getScope: function() {
    var bid = zhlType.getBusinessId()
    if (getQueryString('Scope')) {
      return getQueryString('Scope')
    }
    // web项目Scope拦截
    if (sessionStorage.getItem('Scope')) {
      return sessionStorage.getItem('Scope')
    }
    if (isWeiXin()) {
      if (getTerminal() == 'ios') {
        if (bid == 1) {
          return 'com.zhl.fep.parent.web'
        } else if (bid == 2) {
          return 'com.zhl.english.parent.web'
        } else {
          for (var i = 0; i < zhlType.pressList.length; i++) {
            var pressModel = zhlType.pressList[i]
            if (pressModel.business_id == bid) {
              return 'com.zhl.' + pressModel.mark + '.parent.web'
            }
          }
        }
      } else {
        if (bid == 1) {
          return 'com.zhl.fep.parent.web'
        } else if (bid == 2) {
          return 'com.zhl.english.parent.web'
        } else {
          for (var i = 0; i < zhlType.pressList.length; i++) {
            var pressModel = zhlType.pressList[i]
            if (pressModel.business_id == bid) {
              return 'com.zhl.' + pressModel.mark + '.parent.web'
            }
          }
        }
      }
    } else {
      if (getTerminal() == 'ios') {
        if (bid == 1) {
          return 'com.zhl.enteacher.iphone'
        } else if (bid == 2) {
          return 'com.zhl.enteacher.iphone'
        } else {
          for (var i = 0; i < zhlType.pressList.length; i++) {
            var pressModel = zhlType.pressList[i]
            if (pressModel.business_id == bid) {
              return 'com.zhl.' + pressModel.mark + '.iphone.web'
            }
          }
        }
      } else {
        if (bid == 1) {
          return 'com.zhl.enteacher.iphone'
        } else if (bid == 2) {
          return 'com.zhl.enteacher.iphone'
        } else {
          for (var i = 0; i < zhlType.pressList.length; i++) {
            var pressModel = zhlType.pressList[i]
            if (pressModel.business_id == bid) {
              return 'com.zhl.' + pressModel.mark + '.aphone.web'
            }
          }
        }
      }
    }
    return getTerminal() == 'ios'
      ? 'com.zhl.yj.listen.iphone.web'
      : 'com.zhl.yj.listen.aphone.web'
  },
  getIosVersionScope: function() {
    var bid = zhlType.getBusinessId()
    if (bid == 1) {
      return 'com.zhl.fep.iphone'
    } else if (bid == 2) {
      return 'com.zhl.english.iphone'
    } else {
      for (var i = 0; i < zhlType.pressList.length; i++) {
        var pressModel = zhlType.pressList[i]
        if (pressModel.business_id == bid) {
          return 'com.zhl.' + pressModel.mark + '.iphone'
        }
      }
    }
  },
  // redirectUri跳转链接，url后有参数建议在所有参数后面加一个时间戳
  // isgetinfo是否获取用户信息
  getWechatOpenId: function(redirectUri, isgetinfo, callback) {
    var baseUrl =
      'https%3a%2f%2fzhl-user.xxfz.com.cn%2fapi%2finformation%2fweixinapi%2fgetuseropenidcallback%3fapp_id%3d41%26url%3d'
    var codeUrl = baseUrl + encodeURIComponent(redirectUri)
    if (getQueryString('open_id')) {
      var obj = {}
      obj.open_id = getQueryString('open_id')
      obj.app_id = getQueryString('app_id')
      if (isgetinfo) {
        var params = {
          app_id: Number(getQueryString('app_id')),
          open_id: getQueryString('open_id'),
          op_path: 'information.weixinapi.getweixinuserinfo'
        }
        HttpFactory.postStuUrlNoLoading(params, function(res) {
          obj.userinfo = res
          if (callback) {
            callback(obj)
          } else {
            return obj
          }
        })
      } else {
        return obj
      }
    } else {
      // 原来app_id "wxc4179b005d830163"
      // 微信开放平台appid"wxc4179b005d830163"
      //微信公众号appid"wx223a99b6046b2a69"
      location.replace(
        'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx223a99b6046b2a69&redirect_uri=' +
          codeUrl +
          '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
      )
    }
    // encodeURIComponent
  }
}
var timeHandler = {
  /**
   * 时间戳转时间字符串
   * @param nS 时间戳
   * @param dateSplitChar  时间字符串中日期之间的分隔符
   * @param length  默认显示到秒，截取字符串长度
   * @returns {string}
   */
  getLocalDateTime: function(nS, dateSplitChar, length) {
    var date = new Date(nS * 1000)
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    month = month > 9 ? month : '0' + month
    var day = date.getDate()
    day = day > 9 ? day : '0' + day
    var hour = date.getHours()
    hour = hour > 9 ? hour : '0' + hour
    var minutes = date.getMinutes()
    minutes = minutes > 9 ? minutes : '0' + minutes
    var seconds = date.getSeconds()
    seconds = seconds > 9 ? seconds : '0' + seconds
    if (!dateSplitChar) {
      dateSplitChar = '-'
    }
    if (!length) {
      length = 20
    }
    var str =
      year +
      dateSplitChar +
      month +
      dateSplitChar +
      day +
      ' ' +
      hour +
      ':' +
      minutes +
      ':' +
      seconds
    return str.substr(0, length)
  },
  /**
   * 根据时间字符串计算时间戳,自适应字符串的长度,但不能自定义分隔符
   * @param datestr  形如“2017-12-22 11:04:59”的时间字符串
   * @returns {number}
   */
  calcTimestamp: function(datestr) {
    var arr = datestr.split(' ')
    var date = arr[0] //日期
    var arr0 = date.split('-')
    var year = 2017,
      month = 0,
      day = 1
    switch (arr0.length) {
      case 0:
        break
      case 1:
        year = arr0[0]
        break
      case 2:
        ;(year = arr0[0]), (month = arr0[1] - 1)
        break
      case 3:
        ;(year = arr0[0]), (month = arr0[1] - 1), (day = arr0[2])
        break
    }
    var hour = 0,
      minute = 0,
      second = 0
    if (arr.length > 1) {
      var time = arr[1]
      var arr1 = time.split(':')
      switch (arr1.length) {
        case 0:
          break
        case 1:
          hour = arr1[0]
          break //时
        case 2:
          ;(hour = arr1[0]), (minute = arr1[1])
          break //时、分
        case 3:
          ;(hour = arr1[0]), (minute = arr1[1]), (second = arr1[2])
          break //时、分、秒
      }
    }
    return Date.parse(new Date(year, month, day, hour, minute, second)) / 1000
  },
  /**
   * 根据时间字符串计算剩余时间,自适应字符串的长度,但不能自定义分隔符
   * @param timestr  形如“2017-12-22 11:04:59”的时间字符串
   * @param unit  剩余时间的单位, s-秒  m-分  h-小时  D-天
   * @returns {number}
   */
  calcRemainTime: function(timestr, unit) {
    var time1 = timestr
    if (typeof timestr == 'string') {
      time1 = timeHandler.calcTimestamp(timestr)
    }
    var now = new Date()
    var time2 =
      Date.parse(
        new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate(),
          now.getHours(),
          now.getMinutes(),
          now.getSeconds()
        )
      ) / 1000
    var c = Math.abs(time1 - time2)
    var remainer = 0
    switch (unit) {
      case 's':
        remainer = c
        break
      case 'm':
        remainer = c / 60.0
        break
      case 'h':
        remainer = c / (60.0 * 60)
        break
      case 'D':
        remainer = c / (60.0 * 60 * 24)
        break
    }
    return Math.ceil(remainer)
  },
  /**
   * 时间戳 格式化为 时分秒（00:00:00）
   * 时间秒数格式化
   * @param s 时间戳（单位：秒）
   * @returns {*} getmuchago为false则格式化后的时分秒，
   */
  calcUseTime: function(nS, getmuchago) {
    var t
    if (nS > -1) {
      if (!getmuchago) {
        //获取多少时分秒
        var hour = Math.floor(nS / 3600)
        var min = Math.floor(nS / 60) % 60
        var sec = nS % 60
        if (hour < 10) {
          t = '0' + hour + ':'
        } else {
          t = hour + ':'
        }
        if (min < 10) {
          t += '0'
        }
        t += min + ':'
        if (sec < 10) {
          t += '0'
        }
        t += sec.toFixed(0)
      } else if (getmuchago) {
        //获取
        //刚刚、分钟前、小时前、昨天、天前、月前、年前
        // 以前
        var agodate = new Date(nS * 1000)
        var agoyear = agodate.getFullYear() //年
        var agomonth = agodate.getMonth() + 1 //月
        var agodaytime = agodate.getDate() //日
        var agohour = agodate.getHours() //时
        var agominute = agodate.getMinutes() //分
        // 现在
        var ndate = new Date()
        var nyear = ndate.getFullYear() //年
        var nmonth = ndate.getMonth() + 1 //月
        var ndaytime = ndate.getDate() //日
        var nhour = ndate.getHours() //时
        var nminute = ndate.getMinutes() //分
        if (agoyear < nyear) {
          t = nyear - agoyear + '年前'
        } else if (agoyear == nyear) {
          if (agomonth < nmonth) {
            t = nmonth - agomonth + '月前'
          } else if (agomonth == nmonth) {
            if (agodaytime < ndaytime) {
              if (ndaytime - agodaytime == 1) {
                t = '昨天'
              } else {
                t = nyear - agoyear + '天前'
              }
            } else if (agodaytime == ndaytime) {
              if (agohour < nhour) {
                t = nhour - agohour + '小时前'
              } else if (agohour == nhour) {
                if (agominute < nminute) {
                  t = nminute - agominute + '分钟前'
                } else if (agominute == nminute) {
                  t = '刚刚'
                }
              }
            }
          }
        }
      }
    }
    return t
  }
}
var jumpHttp = {
  // 跳转至孩有为下载官网
  openHywOffcialWeb() {
    jumpWebView.openSystemBrowser('http://haiyouwei.zhihuiliu.com?id=12')
  }
}

let zhl_screen_move_type = {
  startX: 0,
  startY: 0,
  moveEndX: 0,
  moveEndY: 0
}
document.addEventListener('touchstart', function(e) {
  zhl_screen_move_type.startX = e.changedTouches[0].pageX
  zhl_screen_move_type.startY = e.changedTouches[0].pageY
})
document.addEventListener('touchmove', function(e) {
  zhl_screen_move_type.moveEndX = e.changedTouches[0].pageX
  zhl_screen_move_type.moveEndY = e.changedTouches[0].pageY
  let X = zhl_screen_move_type.moveEndX - zhl_screen_move_type.startX
  let Y = zhl_screen_move_type.moveEndY - zhl_screen_move_type.startY
  if (Math.abs(X) > Math.abs(Y) && X > 0) {
    // console.log("右滑");
  } else if (Math.abs(X) > Math.abs(Y) && X < 0) {
    // console.log("左滑");
  } else if (Math.abs(Y) > Math.abs(X) && Y > 0) {
    console.log('下滑')
    var json = { show: 1 }
    var str = JSON.stringify(json)
    if (typeof zhlWebView != 'undefined') {
      zhlWebView.globalPlayAudioShow(str)
    }
  } else if (Math.abs(Y) > Math.abs(X) && Y < 0) {
    console.log('上滑')
    var json = { show: 0 }
    var str = JSON.stringify(json)
    if (typeof zhlWebView != 'undefined') {
      zhlWebView.globalPlayAudioShow(str)
    }
  } else {
    // console.log("just touch");
  }
})

// 学科id配置
const zhl_subjectID = {
  0: { zh: '', en: '' },
  1: { zh: '数学', en: 'Math' },
  2: { zh: '英语', en: 'English' },
  3: { zh: '语文', en: 'Chinese' },
  4: { zh: '物理', en: 'Physics' },
  5: { zh: '化学', en: 'Chemistry' },
  6: { zh: '生物', en: 'Biology' },
  7: { zh: '政治', en: 'Political' },
  8: { zh: '地理', en: 'Geography' },
  9: { zh: '历史', en: 'History' },
  10: { zh: '音乐', en: 'Music' },
  11: { zh: '体育', en: 'PE' },
  12: { zh: '美术', en: 'Art' },
  13: { zh: '劳动', en: 'Labour' },
  14: { zh: '社会', en: 'Social' },
  15: { zh: '科学', en: 'Science' },
  16: { zh: '信息技术', en: 'Information' },
  17: { zh: '思想品德', en: 'Ideology' },
  18: { zh: '通用技术', en: 'Technical' },
  19: { zh: '其他', en: 'Other' }
}
//领取会员短信类型
const MESSAGE_CODE = {
  100023: 22 //辽海
}

function deepCopy(obj, cache = []) {
  // typeof [] => 'object'
  // typeof {} => 'object'
  if (obj === null || typeof obj !== 'object') {
    return obj
  }
  // 如果传入的对象与缓存的相等, 则递归结束, 这样防止循环
  /**
   * 类似下面这种
   * var a = {b:1}
   * a.c = a
   * 资料: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Cyclic_object_value
   */
  const hit = cache.filter(c => c.original === obj)[0]
  if (hit) {
    return hit.copy
  }

  const copy = Array.isArray(obj) ? [] : {}
  // 将copy首先放入cache, 因为我们需要在递归deepCopy的时候引用它
  cache.push({
    original: obj,
    copy
  })
  Object.keys(obj).forEach(key => {
    copy[key] = deepCopy(obj[key], cache)
  })

  return copy
}
;/iphone|ipod|ipad/i.test(navigator.appVersion) &&
  document.addEventListener(
    'blur',
    event => {
      // 当页面没出现滚动条时才执行，因为有滚动条时，不会出现这问题
      // input textarea 标签才执行，因为 a 等标签也会触发 blur 事件
      if (
        document.documentElement.offsetHeight <=
          document.documentElement.clientHeight &&
        ['input', 'textarea'].includes(event.target.localName)
      ) {
        document.body.scrollIntoView() // 回顶部
      }
    },
    true
  )

// 初始化配置mathjax
function initMathjaxConfig() {
  window.MathJax.Hub.Config({
    showProcessingMessages: false, // 关闭js加载过程信息
    messageStyle: 'none', // 不显示信息
    jax: ['input/TeX', 'output/HTML-CSS'],
    skipTags: ['script', 'noscript', 'style', 'textarea', 'pre', 'code', 'a'],
    ignoreClass: 'class1',
    tex2jax: {
      inlineMath: [
        ['$', '$'],
        ['\\(', '\\)']
      ], // 行内公式选择符
      displayMath: [
        ['$$', '$$'],
        ['\\[', '\\]']
      ], // 段内公式选择符
      skipTags: ['script', 'noscript', 'style', 'pre', 'code', 'a'] // 避开某些标签
    },
    'HTML-CSS': {
      availableFonts: ['STIX', 'TeX'], // 可选字体
      showMathMenu: false // 关闭右击菜单显示
    }
  })
}

/**
 * 接口加密处理
 */
function encryption(params) {
  if ((zhlType.getScope() || '').indexOf('.weixin.web') !== -1) {
    const UID = JSON.parse(localStorage.getItem('UID'))
    const uid = UID ? UID : 0
    const randomString = (length, chars) => {
      let result = ''
      for (let i = length; i > 0; --i)
        result += chars[Math.floor(Math.random() * chars.length)]
      return result
    }
    const timestamp = Math.round(new Date() / 1000)
    const nonce = randomString(
      12,
      '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
    )
    const signature = MD5(
      JSON.stringify(params) + uid + timestamp + nonce
    ).toString()
    const visitorGuid = sessionStorage.getItem('visitorGuid')
    if (visitorGuid) {
      return {
        timestamp: timestamp,
        nonce: nonce,
        signature: signature,
        'Visitor-Guid': visitorGuid
      }
    } else {
      return {
        timestamp: timestamp,
        nonce: nonce,
        signature: signature
      }
    }
  } else {
    return {}
  }
}

/**
 * PC字体兼容处理
 */
const PCResize = () => {
  if (getTerminal() !== 'ios' && getTerminal() !== 'android') {
    let tid = null
    // 设置最大宽高比
    const maxRatio = 0.75
    const htmlStyle = document.getElementsByTagName('html')[0].style
    htmlStyle.margin = '0 auto'
    if (
      window.innerWidth > 600 &&
      window.innerWidth > window.innerHeight * maxRatio
    ) {
      const shouldWidth = window.innerHeight * maxRatio
      htmlStyle.maxWidth = shouldWidth + 'px'
      htmlStyle.fontSize = shouldWidth / 10.0 + 'px'
    }
    // 当宽度大于800且宽度大于高度的75%
    window.addEventListener(
      'resize',
      e => {
        clearTimeout(tid)
        tid = setTimeout(() => {
          if (
            window.innerWidth > 600 &&
            window.innerWidth > window.innerHeight * maxRatio
          ) {
            const shouldWidth = window.innerHeight * maxRatio
            htmlStyle.maxWidth = shouldWidth + 'px'
            htmlStyle.fontSize = shouldWidth / 10.0 + 'px'
          }
        }, 300)
      },
      false
    )
    window.addEventListener(
      'pageshow',
      e => {
        if (e.persisted) {
          clearTimeout(tid)
          tid = setTimeout(() => {
            if (
              window.innerWidth > 600 &&
              window.innerWidth > window.innerHeight * maxRatio
            ) {
              const shouldWidth = window.innerHeight * maxRatio
              htmlStyle.maxWidth = shouldWidth + 'px'
              htmlStyle.fontSize = shouldWidth / 10.0 + 'px'
            }
          }, 300)
        }
      },
      false
    )
  }
}

/**
 * 判断是PC环境，动态引入滚动条修改样式
 */
const includeLinkStyle = (url, ico) => {
  const link = document.createElement('link')
  link.rel = 'icon'
  link.href = ico
  document.head.appendChild(link)
  if (getTerminal() === 'ios' || getTerminal() === 'android') {
    return false
  } else {
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.type = 'text/css'
    link.href = url
    document.getElementsByTagName('head')[0].appendChild(link)
  }
}
/**
 * @description 判断是否是pc端
 * @returns true or false
 */
const isPC = () => {
  return !['ios', 'android'].includes(getTerminal())
}
/**
 * @description 公共的退出时要清理的数据
 */
const loginOut = () => {
  sessionStorage.removeItem('token')
  setCookie('token', '')
  localStorage.removeItem('user_role')
  localStorage.removeItem('user_info')
  sessionStorage.removeItem('active')
}
/**
 * @description 提交错误日志 
 */
const submitErrorLog = (source, error) => {
  if (typeof error === 'object') {
    error = JSON.stringify(error)
  }
  if (error && typeof error === 'string') {
    if (error.length > 5000) {
      error = error.substring(0, 5000)
    }
    HttpFactory.postNotokenNoLoading({
      op_path: 'information.log.addloginfo',
      source: source || '',
      content: error || ''
    }).then((res) => {
      console.log('提交错误日志成功')
      console.log(error)
    })
  }
}
;(function() {
  if (getQueryString('UID')) {
    localStorage.setItem('UID', getQueryString('UID'))
  }
  if (getQueryString('Scope')) {
    sessionStorage.setItem('Scope', getQueryString('Scope'))
  }
  if (getQueryString('visitorGuid')) {
    sessionStorage.setItem('visitorGuid', getQueryString('visitorGuid'))
  }
  if (getQueryString('isZHLFormal')) {
    sessionStorage.removeItem('visitorGuid')
  }
  if (getQueryString('token')) {
    sessionStorage.removeItem('token')
    sessionStorage.setItem('token', getQueryString('token'))
    setCookie('token', getQueryString('token'))
    // 重定向修改url参数(抹除token)
    if (history.replaceState) {
      const newUrl = window.location.href.replace(
        /token=([^&]*)/gi,
        'savetoken=1'
      )
      window.history.replaceState(null, window.document.title, newUrl)
    }
  }
  includeLinkStyle(
    `${location.protocol}${process.env.VUE_APP_WEB_ADDRESS}/scrollbar/scrollbar.css`,
    `${location.protocol}${
      process.env.VUE_APP_WEB_ADDRESS
    }/app-all-logo/${zhlType.getBusinessId()}/icon-logo.ico`
  )
})()
export {
  godPolicy,
  HttpFactory,
  setCookie,
  getQueryString,
  getCookie,
  delCookie,
  zhlType,
  isWeiXin,
  timeHandler,
  getTerminal,
  jumpWebView,
  jumpHttp,
  getArgs,
  md5,
  iosOrAndroid,
  zhl_subjectID,
  showLoading,
  closeLoading,
  ApiUrl,
  MESSAGE_CODE,
  ifTest,
  deepCopy,
  initMathjaxConfig,
  PCResize,
  isPC,
  loginOut,
  submitErrorLog
}
